import React from "react";

const TextInput = React.memo(
    ({
        unit,
        onChange,
        value,
        labelList,
        name,
        type,
        extraInfo = undefined,
        textAlign = "center",
        width = 40,
        height = 30,
        fontSize = 12,
        margin,
        disabled = false,
    }) => {
        const handleOnChange = (event) => {
            const value = event.target.value;
            if (type === "number") {
                if (isNaN(Number(value))) return;
                return onChange({
                    value: Number(value),
                    labelList,
                    name,
                    extraInfo,
                });
            } else onChange({ value, labelList, name, extraInfo });
        };
        return (
            <div className="flex items-center">
                <input
                    type="text"
                    onChange={handleOnChange}
                    value={value}
                    disabled={disabled}
                    className="border border-[#dadada] font-['decimal_book']"
                    style={{
                        width,
                        height,
                        fontSize,
                        margin,
                        textAlign,
                    }}
                />
                {unit && (
                    <span className="ml-[6px] text-[12px] font-['decimal_book']">
                        {unit}
                    </span>
                )}
            </div>
        );
    }
);

export default TextInput;
